module.exports = __webpack_public_path__ + "img/multiLineTextEle.15b7a3f1.svg";